import PaperflyAPI from '../../../../server/api/PaperflyAPI';

export const checkSignmeAccount = (
  onDone,
  recipientRequestId,
  emailAddress,
  mobilePhoneNumber,
  familyNames,
  givenNames
) => {
  PaperflyAPI.signmeGetUser(
    recipientRequestId,
    emailAddress,
    mobilePhoneNumber,
    familyNames,
    givenNames
  ).then(
    response => {
      const userState =
        response.signmeUser && response.signmeUser.identityVerificationState;
      const signingPossible =
        response.signmeUser && response.signmeUser.signingPossible;
      const registrationDialogClosed =
        response.signmeUser && response.signmeUser.registrationDialogClosed;

      if (
        [
          'LAWFUL_VERIFICATION_REQUESTED',
          'LAWFUL_VERIFICATION_STARTED'
        ].includes(userState) ||
        (!signingPossible && userState === 'LAWFULLY_VERIFIED_HIGH')
      ) {
        onDone(false, response.signmeUser);
        return;
      }

      if (signingPossible && userState === 'LAWFULLY_VERIFIED_HIGH') {
        onDone(true, {
          identityId: response.signmeUser.identityId,
          registrationDialogClosed
        });
        return;
      }

      onDone();
    },
    error => {
      onDone();
    }
  );
};
